import { type ThemeOptions } from "@mui/material/styles";

import { colors } from "design-tokens";

/**
 * Every step is stated rather than derived: MUI's `addLightOrDark` fills a missing `light` from
 * `[300]` and a missing `dark` from `[700]`, so deleting one as redundant silently repoints it.
 */
export const palette: ThemeOptions["palette"] = {
  mode: "light",
  primary: {
    lighter: colors.aqua[50],
    main: colors.aqua[600],
    light: colors.aqua[400],
    dark: colors.aqua[700],
    contrastText: colors.white,
  },
  secondary: {
    lighter: colors.navy[100],
    main: colors.navy[800],
    light: colors.navy[300],
    dark: colors.navy[900],
    contrastText: colors.white,
  },
  accent: {
    lighter: colors.lime[100],
    main: colors.lime[700],
    light: colors.lime[400],
    dark: colors.lime[900],
    contrastText: colors.white,
  },
  error: {
    lighter: colors.critical[50],
    main: colors.critical[700],
    light: colors.critical[300],
    dark: colors.critical[800],
    contrastText: colors.white,
  },
  warning: {
    lighter: colors.warning[100],
    main: colors.warning[700],
    light: colors.warning[400],
    dark: colors.warning[800],
    contrastText: colors.white,
  },
  info: {
    lighter: colors.blue[100],
    main: colors.blue[700],
    light: colors.blue[400],
    dark: colors.blue[800],
    contrastText: colors.white,
  },
  success: {
    lighter: colors.success[100],
    main: colors.success[700],
    light: colors.success[400],
    dark: colors.success[800],
    contrastText: colors.white,
  },
  grey: {
    50: colors.neutrals[50],
    100: colors.neutrals[100],
    200: colors.neutrals[200],
    300: colors.neutrals[300],
    400: colors.neutrals[400],
    500: colors.neutrals[500],
    600: colors.neutrals[600],
    700: colors.neutrals[700],
    800: colors.neutrals[800],
    900: colors.neutrals[900],
  },
  text: {
    primary: colors.neutrals[900],
    secondary: colors.neutrals[600],
    disabled: colors.neutrals[500],
  },
  heading: {
    primary: colors.navy[800],
    secondary: colors.neutrals[900],
  },
  background: {
    default: colors.neutrals[100],
    paper: colors.white,
  },
  /** The second line step lives in `border.tertiary`; MUI types `divider` as a single string. */
  divider: colors.neutrals[200],
  /** The three line weights a surface can be outlined with. */
  border: {
    primary: colors.neutrals[100],
    secondary: colors.neutrals[200],
    tertiary: colors.navy[200],
  },
  common: {
    white: colors.white,
    black: colors.neutrals[900],
  },
};
